const gradient = {
  menu: 'linear-gradient(15deg, #1E2647 0%, #010103 100%)',
  page: 'linear-gradient(65deg, #1E2647 0%, #010103 100%)',
};

export type SystemGradientMap = typeof gradient;
export type SystemGradient = keyof SystemGradientMap;

export default gradient;
